[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 6,
                "y": 3,
                "key": "45KgB"
            },
            {
                "x": 6,
                "y": 2,
                "key": "tLpRoiW2EvVrLyND4pBYF"
            },
            {
                "x": 7,
                "y": 2,
                "key": "JgJ7e"
            },
            {
                "x": 7,
                "y": 1,
                "key": "EfBMj"
            },
            {
                "x": 10,
                "y": 1,
                "key": "wmWV6"
            },
            {
                "x": 10,
                "y": 2,
                "key": "2XDcO"
            },
            {
                "x": 11,
                "y": 2,
                "key": "7gTwWqlCkIq9wxOI9wDMl"
            },
            {
                "x": 11,
                "y": 3,
                "key": "LKUnM"
            },
            {
                "x": 11,
                "y": 4,
                "key": "cFzY_"
            },
            {
                "x": 10,
                "y": 4,
                "key": "x_4do"
            },
            {
                "x": 10,
                "y": 5,
                "key": "UxoH3"
            },
            {
                "x": 9,
                "y": 5,
                "key": "z9Nn61pWmpd489F0Co-yj"
            },
            {
                "x": 8,
                "y": 5,
                "key": "2smmW"
            },
            {
                "x": 7,
                "y": 5,
                "key": "Lc97b"
            },
            {
                "x": 7,
                "y": 4,
                "key": "-AOdY"
            },
            {
                "x": 6,
                "y": 4,
                "key": "stOEn_4Hof8z7g2cDFKPY"
            }
        ]
    }
]